/*
 * event common service
 *
 * (c) 2017/8/7 lihaozhou
 * Email: lihaozhou@wps.cn
 * License: KSO
 */
import execService from './../exec';

/**
 * 叠加的id
 * @returns {number}
 */
function getRandom() {
  return setTimeout(function () {
  }, 0);
}

/**
 * 事件回调函数名
 * @returns {string}
 */
function getCallbackName() {
  return 'event_async_callback_' + getRandom();
}

class EventService {

  constructor() {

    this.apiPrefix = 'common.event';

    this.apis = {
      addEventListener: `${this.apiPrefix}.addEventListener`,
      removeEventListener: `${this.apiPrefix}.removeEventListener`
    };

    this.mapping = {};
  }

  /**
   * 底层增加事件监听
   * @param eventName 事件名
   * @param callbackName 回调函数名
   * @private
   */
  _addEventListener(eventName, callbackName) {
    execService.exec(this.apis.addEventListener, {eventName, callbackName});
  }

  /**
   * 底层移除事件监听
   * @param eventName 事件名
   * @private
   */
  _removeEventListener(eventName) {
    execService.exec(this.apis.removeEventListener, {eventName});
  }

  /**
   * 增加监听事件
   * @param eventName 事件名
   * @param callback 回调函数
   */
  addEventListener(eventName, callback) {

    if (typeof callback !== 'function') {
      console.warn('callback must be function');
      return;
    }

    let callbackName = getCallbackName();

    this.mapping[eventName] = callbackName;

    window[callbackName] = (response) => {
      response = execService.decode(response);
      response = JSON.parse(response);
      callback(response);
    };

    this._addEventListener(eventName, callbackName);
  }

  /**
   * 移除事件监听
   * @param eventName 事件名
   */
  removeEventListener(eventName) {
    this._removeEventListener(eventName);

    let callbackName = this.mapping[eventName];

    if (callbackName) {
      delete window[callbackName];
      delete this.mapping[eventName];
    }
  }
}

export default new EventService();
